var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideDropdown,
          expression: "hideDropdown",
        },
      ],
      staticClass: "self-center",
    },
    [
      _vm.dropdownMode
        ? _c("UiButton", {
            staticClass: "-mr-4",
            attrs: { size: "lg", variant: "empty" },
            on: { click: _vm.toggleDropdown },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon",
                  fn: function () {
                    return [_c("DotsVerticalIcon", { staticClass: "w-4 h-4" })]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              500884367
            ),
          })
        : _vm._e(),
      _c("div", { staticClass: "relative" }, [
        _c("div", { class: _vm.slotClass }, [_vm._t("default")], 2),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }